// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__ppAYA","ih4":"Banner_ih4__vLZ3W","ih41":"Banner_ih41__lNgQK"};